import { api } from './api';

const getUserTypeGroupsById = async ({id}) => {
    const response = await api({
        url: `UserTypeGroups/getusertypegroupsbyusertypeid`,
        method: 'GET',
        params: {
            userTypeId: id,
        },
    });
    return response.data;
};

const addUserTypeGroups = async (data) => {
    const response = await api({
        url: `UserTypeGroups/add`,
        method: 'POST',
        data: data.entity,
    });
    return response.data;
};

const deleteUserTypeGroups = async ({id}) => {
    const response = await api({
        url: `UserTypeGroups/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            id,
            customerId: window.customerId
        },
    });
    return response.data;
};

const userTypeGroupsServices = {
  getUserTypeGroupsById,
  addUserTypeGroups,
  deleteUserTypeGroups,
};

export default userTypeGroupsServices;
